export default __webpack_public_path__ + "static/media/right_arrow.3659f07e.svg";